module.exports = __webpack_public_path__ + "img/claude.1ce67991.svg";